import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import styled from '@mui/system/styled';
import { CloseCircleIcon } from '../icons';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import theme from '@/mui/theme';
import { getDefaultSortOrder } from '@/utils/slug';

interface ActiveFilterProps {
  title?: string;
  chips: string[];
  storeData: {
    storeId: string
    langId: string
    catalogId: string
    locale: string
    categoryId: string,
    orderBy: string,
    pageNumber: string,
    pageSize: string
  }
  handleFilter: Function;
  btnRemoveFilters: string;
}

const StyledBox = styled(Box)({
  backgroundColor: '#f1f1f1',
  padding: '20px 16px',
  [theme.breakpoints.up('sm')]: {
    padding: '10px 21px 31px 14px',
  }
});

const StyledTitle = styled(Typography)({
  fontSize: '18px',
  letterSpacing: '0',
  lineHeight: '26px',
  marginBottom: '11px',
  [theme.breakpoints.up('sm')]: {
    marginBottom: '27px',
  }
});

const StyledChip = styled(Chip)({
  backgroundColor: '#1288CF',
  color: '#ffffff',
  fontSize: '14px',
  letterSpacing: '0',
  lineHeight: '20px',
  padding: '5px 5px 5px 10px',
  borderRadius: '12px',
  marginRight: '7px',
  marginBottom: '7px',
  '&:hover': {
    backgroundColor: '#1288CF',
    color: '#ffffff'
  },
  '.MuiChip-label': {
    paddingLeft: '0',
    paddingRight: '5px'
  },
  '.MuiChip-deleteIcon': {
    color: '#ffffff',
    margin: '0',
    '&:hover': {
      color: '#ffffff'
    }
  },
  [theme.breakpoints.up('sm')]: {
    marginRight: '10px',
    marginBottom: '10px',
  }
});

const StyledBtn = styled(Button)({
    fontSize: '14px',
    letterSpacing: '0',
    lineHeight: '17px',
    fontWeight: 'bold',
    color: '#182641',
    padding: '0',
    marginTop: '19px',
    minWidth: '0',
    '&:hover, &:active': {
      backgroundColor: 'unset',
      color: '#182641',
    },
    [theme.breakpoints.up('sm')]: {
      marginTop: '25px',
    }
});

const ActiveFilter: React.FC<ActiveFilterProps> = ({ title, chips, storeData, handleFilter, btnRemoveFilters }) => {
  /* const [chipsList, setChipsList] = useState(chips); */
  const chipsList = chips;

  const handleDelete = (chipToDelete: any) => () => {
    console.info('You clicked the delete chip: %s', chipToDelete);
    let queryParams = {
      storeId: storeData.storeId,
      langId: storeData.langId,
      catalogId: storeData.catalogId,
      locale: storeData.locale,
      categoryId: storeData.categoryId,
      filterValue: chipToDelete,
      sliderFilterValueDeleted: true,
      orderBy: storeData.orderBy,
      pageNumber: storeData.pageNumber,
      pageSize: storeData.pageSize
    }
    handleFilter(queryParams);
    //setChipsList(chipsList.filter((chip) => chip !== chipToDelete));
  };

  const handleDeleteAll = () => {
    let queryParams = {
      storeId: storeData.storeId,
      catalogId: storeData.catalogId,
      locale: storeData.locale,
      langId: storeData.langId,
      categoryId: storeData.categoryId,
      filterValue: null,
      sliderFilterValueDeleted: true,
      orderBy: getDefaultSortOrder(),
      pageNumber: storeData.pageNumber,
      pageSize: storeData.pageSize
    }
    handleFilter(queryParams);
  };

  if (chipsList && chipsList.length > 0) {
    return <Grid item xs={12} sx={{ mb: '35px'}}>
      <StyledBox>
        {title &&
          <StyledTitle>{title}</StyledTitle>
        }
        <Stack direction="row" sx={{ flexWrap: 'wrap' }}>
          {chipsList && chipsList.length > 0 && chipsList.map(mapChips.bind(null,handleDelete))}
        </Stack>
        {btnRemoveFilters &&
          <StyledBtn onClick={handleDeleteAll}>{btnRemoveFilters}</StyledBtn>
        }
      </StyledBox>
    </Grid>
  } else {
    return <></>;
  }
}

const mapChips = (handleDelete: Function, singleChip: any, index: number) => {
  return <StyledChip key={index} label={singleChip.value?.replace('&nbsp;','')} deleteIcon={<CloseCircleIcon />} onClick={handleDelete(singleChip.name)} onDelete={handleDelete(singleChip.name)} />
}

export default ActiveFilter;
